import { render, staticRenderFns } from "./ProductTimeDiscountView.vue?vue&type=template&id=03d03afa&"
import script from "./ProductTimeDiscountView.vue?vue&type=script&lang=js&"
export * from "./ProductTimeDiscountView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports